<template>
  <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 1.5a6.5 6.5 0 100 13.001A6.5 6.5 0 008 1.5zM.5 8a7.5 7.5 0 1115.001 0A7.5 7.5 0 01.5 8zM8 7.5a.5.5 0 01.5.5v3.501a.5.5 0 01-1 0v-3.5a.5.5 0 01.5-.5zm0-1.25A.875.875 0 108 4.5a.875.875 0 000 1.75z"
      fill="currentColor"
    />
  </svg>
</template>
